module.exports = __webpack_public_path__ + "static/media/20201114_154353_721_IMG_9973.4c30e3f2.jpg";